import { useTranslation } from 'next-i18next'
import { DefaultModal } from '../default-modal'
import { Heading, Stack, Text } from '@chakra-ui/react'
import { NewsletterOptInForm } from '../../forms/newsletter-opt-in-form'
import type { NotifyMeAttributes, NotifyMeOptInInput } from '@twlvxtwlv/types'

interface NotifyMeModalProps {
  isOpen: boolean
  onClose: () => void
  onNotifyMeSubmit: (notifyMeOptInInput: NotifyMeOptInInput) => void
  onNotifyMeAttributesChanged: (attributes: NotifyMeAttributes | null) => void
}

export function NotifyMeModal({
  isOpen,
  onClose,
  onNotifyMeSubmit,
  onNotifyMeAttributesChanged,
}: NotifyMeModalProps) {
  const { t } = useTranslation('campaign')

  function handleOnClose() {
    onClose()
    onNotifyMeAttributesChanged(null)
  }

  return (
    <DefaultModal
      isOpen={isOpen}
      onClose={handleOnClose}
      closeOnOverlayClick
      showCloseButton={true}
      backgroundColor="white"
      size="xl"
      body={
        <Stack gap={4} fontSize={['xs', 'xs', 'sm']}>
          <Heading textAlign={'center'} fontSize={['lg', 'lg', 'xl']}>
            {t('notify-me-modal-title')}
          </Heading>
          <Text fontSize="lg" fontWeight="400">
            {t('notify-me-modal-content')}
          </Text>
          <NewsletterOptInForm onSubmit={onNotifyMeSubmit} variant="default" />
        </Stack>
      }
    />
  )
}
